<div [class]="'bolletje ' + (data.aantalGeactiveerdeLeermiddelen == 0 ? 'geen' : '')">
  <span>{{data.aantalGeactiveerdeLeermiddelen}}</span>
</div>
<span class="naam">
  {{data.leerlingNaam}}
</span>
